import { useRoute, useRouter } from "vue-router";

export enum UrlAnchor {
  OpenGallery = "gallery",
  ItemsTabs = "items-tabs",
}

export function useUrlAnchor() {
  const router = useRouter();

  const addAnchorToUrl = (anchor: string) => {
    const routeCurrent = router.currentRoute.value;
    router.push({ ...routeCurrent, hash: "#" + anchor });
  };
  const clearAnchorFromUrl = () => router.push({ hash: "" });

  const route = useRoute();
  const currentAnchor = computed(() => route.hash.substring(1));

  return {
    addAnchorToUrl,
    clearAnchorFromUrl,
    currentAnchor,
  };
}
